<p-toast></p-toast>
@if (fsvc.formLoading()) {
  <p-progress-bar mode="indeterminate" [style]="{ height: '4px' }"></p-progress-bar>
} @else {
  @if(fsvc.form) {
    <p-tabs value="0" [lazy]="true">
      <div class="flex-row flex-justify-between">
        <p-tablist>
          <p-tab routerLink="/forms/builder/index">
            <i class="fa fa-chevron-left"></i>
          </p-tab>
          <p-tab value="0">{{'Properties'|transloco}}</p-tab>
          <p-tab value="1">{{'Fields'|transloco}}</p-tab>
          <p-tab value="2">{{'Assignments'|transloco}}</p-tab>
        </p-tablist>
        <div class="additiona-tablist-right">
          <div class="flex-row gap-16px flex-align-stretch">

            <p-button
              icon="fa-regular fa-floppy-disk"
              severity="danger"
              label="{{ 'Save Form' | transloco }}"
              (onClick)="submit()"
            />

            @if(formId() > 0 && !fsvc.form_json.isHTMLForm) {
              <p-button
                icon="fa-regular fa-copy"
                variant="outlined"
                label="{{ 'Duplicate Form'|transloco }}"
                (onClick)="duplicate()"
              />
            }

          </div>
        </div>
      </div>
      <p-tabpanels class="p-bordered-tab-panel">
        <p-tabpanel value="0">
          <ng-edit-properties-tab style="display: block;max-width: 1000px"></ng-edit-properties-tab>
        </p-tabpanel>
        <p-tabpanel value="1">
          <ng-edit-fields-tab></ng-edit-fields-tab>
        </p-tabpanel>
        <p-tabpanel value="2">
          <ng-edit-assignments-tab style="display: block;max-width: 1000px"></ng-edit-assignments-tab>
        </p-tabpanel>
      </p-tabpanels>
    </p-tabs>
  }
}
